/**
 * Created by Tukta on 15/7/2560.
 */
import React, { Component } from 'react'
import moment from 'moment'
import BigCalendar from 'react-big-calendar'
import axios from 'axios'
import { APIURL} from '../../../config/config'

const localizer = BigCalendar.momentLocalizer(moment)

/*BigCalendar.setLocalizer(
    BigCalendar.globalizeLocalizer(globalize)
);*/

require ("react-big-calendar/lib/css/react-big-calendar.css");


export  default class CalendarList extends Component{
    constructor (props){
        super(props);
        this.state ={
            data:[],
            birth:[],
            car: ''
        }
    }

    loadData () {
        axios.get(APIURL + '/calendar_car_license/forplan/')
            .then(res => {
                //console.log(res.data)
                this.setState({data:res.data})
            }).catch(error => {
            this.setState({data: []})
        })
    }

    componentDidMount() {
        this.loadData()
    }

    eventStyleGetter(event, start, end, isSelected) {
        //console.log(event);
        var backgroundColor = '#' + event.hex_color;
        var style = {
            backgroundColor: backgroundColor,
            borderRadius: '5px',
            opacity: 0.8,
            color: 'white',
            border: '0px',
            display: 'block',
        };
        return {
            style: style
        };
    }

    render(){

        return (
            <div className="card">
                <div className="card-block">
                    <div className="row">
                        <div className="col-sm-12 col-md-12">
                            <div className="card card-accent-info">
                                <div className="card-header">
                                    <strong> ปฏิทินเตือนความจำ </strong>
                                </div>

                                <div className="card-block">
                                    <BigCalendar
                                        localizer={localizer}
                                        selectable
                                        style={{height: '960px' , backgroundColor:'#ffffff'}}
                                        events={this.state.data}
                                        defaultView='month'
                                        defaultDate={new Date()}
                                        onSelectEvent={event => alert(event.title)}
                                        eventPropGetter={(this.eventStyleGetter)}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
